import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "maskType" }, "Mask", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "contactNumbers" }, "Contact Numbers", -1)
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  key: 0,
  for: "contactList"
}
const _hoisted_13 = { class: "list-item-container" }
const _hoisted_14 = { class: "button-group" }
const _hoisted_15 = {
  class: "dialog-footer-fixed",
  style: {"position":"sticky","bottom":"0","background":"#f5f5f5","padding":"10px","box-shadow":"0 -2px 5px rgba(0,0,0,0.1)","border-bottom":"1px solid #ddd"}
}
const _hoisted_16 = { style: {"display":"flex"} }
const _hoisted_17 = {
  class: "button-container",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_18 = { class: "p-mx-1" }
const _hoisted_19 = { class: "confirmation-content" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.productDialog,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
      style: { width: '50vw' },
      maximizable: true,
      position: "top",
      class: "p-fluid",
      modal: true,
      closable: true,
      onHide: _ctx.closeDialog
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "promotionName",
            class: _normalizeClass({ 'p-error': _ctx.v$.promotionName.$invalid && _ctx.submitted })
          }, "Promotion Name", 2),
          _createVNode(_component_InputText, {
            id: "promotionName",
            modelValue: _ctx.state.promotionName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.promotionName) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({ 'p-invalid': _ctx.v$.promotionName.$invalid && _ctx.submitted }),
            autoFocus: ""
          }, null, 8, ["modelValue", "class"]),
          (_ctx.v$.promotionName.$invalid && _ctx.submitted)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.v$.promotionName.required.$message.replace("Value", "Promotion Name")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            id: "maskType",
            modelValue: _ctx.item.maskType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.maskType) = $event)),
            options: _ctx.maskTypes,
            optionLabel: "key"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            for: "message",
            class: _normalizeClass({ 'p-error': _ctx.v$.message.$invalid && _ctx.submitted })
          }, "Message", 2),
          _createVNode(_component_Textarea, {
            id: "message",
            modelValue: _ctx.state.message,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.message) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({ 'p-invalid': _ctx.v$.message.$invalid && _ctx.submitted }),
            maxlength: "320",
            rows: "1",
            autoResize: true
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("small", null, _toDisplayString(160 - _ctx.state.message.length < 0 ? 320 - _ctx.state.message.length : 160 - _ctx.state.message.length) + " / " + _toDisplayString(_ctx.smsPerNumber), 1),
          (_ctx.v$.message.$invalid && _ctx.submitted)
            ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.message.required.$message.replace("Value", "Message")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, [
            _createVNode(_component_Chips, {
              modelValue: _ctx.newContactNumbers,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newContactNumbers) = $event)),
              readonly: true
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.incorretContactNumbers.length > 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_12, "Invalid Numbers (" + _toDisplayString(_ctx.incorretContactNumbers.length) + ")", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incorretContactNumbers, (contact, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "contact-item"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(contact), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-pencil",
                        class: "p-button-rounded p-button-primary p-mr-2",
                        onClick: ($event: any) => (_ctx.EditInvalidContact(index))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-trash",
                        class: "p-button-rounded p-button-danger",
                        onClick: ($event: any) => (_ctx.removeInvalidContact(index))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 2
    }, [
      (!_ctx.previewOnly)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.editingNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingNumber) = $event)),
                    placeholder: "Add a number",
                    style: {"flex-grow":"1","margin-right":"10px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Button, {
                    label: "Add Number",
                    icon: "pi pi-plus",
                    class: "p-button-info",
                    style: {"width":"360px"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.UpdateInvalidContact()))
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Button, {
                  type: "submit",
                  label: "save",
                  icon: "pi pi-check",
                  class: "p-button-primary green-button",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.savePromotion(!_ctx.v$.$invalid)), ["prevent"]))
                }),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-upload",
                    label: "Upload Stock CSV",
                    class: "p-button-primary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openFileUploader()))
                  })
                ])
              ]),
              _createVNode(_component_FileUploader, {
                uploaderDetail: {
          status: _ctx.uploaderStatus,
          dialogTitle: 'Upload Stock CSV file:',
          imageType: '.csv',
        },
                onUpdateUploaderStatus: _ctx.updateUploaderStatus
              }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"])
            ])
          }
        : undefined
    ]), 1032, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.statusDialog,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.statusDialog) = $event)),
      style: { width: '450px' },
      header: _ctx.popupDialogTitle
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "OK",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.statusDialog = false))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_ctx.notificationDialogBody), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}